import CardsItem from './CardsItem';
import { CardsItemSkeleton } from './CardsItem';

export default CardsItem;

export { CardsItemSkeleton };
